import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class SendChatMessageCommand extends IRequestCommand<ISendChatMessageResponse, ErrorDetails, ISendChatMessageCommandParameter> {
    showHttpErrorMessage(error: any) {
      throw new Error('Method not implemented.');
    }
    override _commandType: CommandRequestType = CommandRequestType.POST;
    override _commandUrl = 'chats/add/text';
}

export interface ISendChatMessageCommandParameter{
    recipient: string;
    sender: string;
    driverId: number;
    carrierId: number;
    message: string;
    driverName: string;
    operatorName: string;
    tokenRecipient: string;
    platform: string;
}

export interface ISendChatMessageResponse {
}